/**
 * Created by Ning Jiang on 2/7/2019.
 */

import {BetLinesView} from "@nolimitcity/slot-game/bin/core/betline/BetLinesView";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {GameTweakerTest} from "@nolimitcity/slot-game/bin/dev/tweaker/test/GameTweakerTest";
import {PolyBetLine} from "@nolimitcity/slot-game/bin/game/betline/line/PolyBetLine";
import {BookOfShadowsFontConfig} from "./BookOfShadowsFontConfig";
import {BookOfShadowsGameAssets} from "./BookOfShadowsGameAssets";
import {BookOfShadowsSoundConfig} from "./BookOfShadowsSoundConfig";
import {BookOfShadowsServerDataParser} from "./server/BookOfShadowsServerDataParser";
import {BookOfShadowsParsedGameData} from "./server/data/BookOfShadowsParsedGameData";
import {BookOfShadowsParsedInitData} from "./server/data/BookOfShadowsParsedInitData";
import {SpinStart} from "./gameround/spin/SpinStart";
import {ReelStart} from "./gameround/reel/ReelStart";
import {SpinStop} from "./gameround/spin/SpinStop";
import {InitialWin} from "./gameround/initialWin/InitialWin";
import {BigWinStep} from "./gameround/bigWin/BigWinStep";
import {WinEnd} from "./gameround/winEnd/WinEnd";
import {ReelStop} from "./gameround/reel/ReelStop";
import {CountUpView} from "./views/CountUpView";
import {BookOfShadowsReelSymbolStateCreator} from "./symbols/BookOfShadowsReelSymbolStateCreator";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {BookOfShadowsGameMode} from "./gameMode/BookOfShadowsGameMode";
import {BookOfShadowsGameRoundPresentation} from "./gameround/BookOfShadowsGameRoundPresentation";
import {BookOfShadowsReelBackgroundView} from "./reelBackground/BookOfShadowsReelBackgroundView";
import {BookOfShadowsTextBetLineNumber} from "./betline/BookOfShadowsTextBetLineNumber";
import {BookOfShadowsInactiveRowController} from "./inactiveRow/BookOfShadowsInactiveRowController";
import {BookOfShadowsReelController} from "./reel/BookOfShadowsReelController";
import {BookOfShadowsReelLockController} from "./reelLock/BookOfShadowsReelLockController";
import {BookOfShadowsSymbolsWinAnimations} from "./winAnimations/symbols/BookOfShadowsSymbolsWinAnimations";
import {BookOfShadowsBetLineWin} from "./gameround/betLineWin/BookOfShadowsBetLineWin";
import {BookOfShadowsReelSymbol} from "./symbols/BookOfShadowsReelSymbol";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {GameRoundConfig} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";
import {GameModeTransitionController} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {BookOfShadowsGameConfig} from "./BookOfShadowsGameConfig";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {BookOfShadowsSymbolIdleAnimationController} from "./gameround/idleAnimation/symbolIdleAnimation/BookOfShadowsSymbolIdleAnimationController";
import {BookOfShadowsBetLine} from "./betline/BookOfShadowsBetLine";
import {BookOfShadowsScatterWinController} from "./gameround/scatterWin/BookOfShadowsScatterWinController";
import {BookOfShadowsZeroBet} from "./gameround/zeroBet/BookOfShadowsZeroBet";
import {BookOfShadowsReelLockButtonIdleAnimationController} from "./gameround/idleAnimation/reelLockButtonIdleAnimation/BookOfShadowsReelLockButtonIdleAnimationController";
import {BookOfShadowsBigWinView} from "./views/BookOfShadowsBigWinView";
import {BookOfShadowsSpinReelPartAnimator} from "./reel/spinReel/BookOfShadowsSpinReelPartAnimator";
import {BookOfShadowsNearWinView} from "./views/BookOfShadowsNearWinView";
import {BookOfShadowsNearWin} from "./gameround/nearWin/BookOfShadowsNearWin";
import {BookOfShadowsFreeSpinIntroTransitionController} from "./transitions/freeSpinIntro/BookOfShadowsFreeSpinIntroTransitionController";
import {BookOfShadowsBackground} from "./background/BookOfShadowsBackground";
import {BookOfShadowsFreeSpinOutroTransitionController} from "./transitions/freeSpinOutro/BookOfShadowsFreeSpinOutroTransitionController";
import {BookOfShadowsBetLineWinAmountView} from "./betline/BookOfShadowsBetLineWinAmountView";
import {MiniCoinShower} from "./views/MiniCoinShower";
import {GambleTransitionController} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GambleTransitionController";
import {BookOfShadowsGambleBet} from "./gameround/zeroBet/BookOfShadowsGambleBet";
import {FireParticles} from "./views/FireParticles";
import {CoinsFountain} from "./views/CoinsFountain";
import {BookOfShadowsExitGambleTransition} from "./transitions/BookOfShadowsExitGambleTransition";
import {GameTutorialController} from "./gameround/idleAnimation/gameTutorial/GameTutorialController";
import {BookOfShadowsReTriggerController} from "./transitions/freeSpinReTrigger/BookOfShadowsReTriggerController";
import {SoundManager} from "./sound/SoundManager";
import {BookOfShadowsTimelineReelsController} from "./reel/BookOfShadowsTimelineReelsController";
import {BookOfShadowsPaytableView} from "./views/BookOfShadowsPaytableView";
import {FeaturePrice} from "./utils/FeaturePrice";

export class BookOfShadowsGameModuleConfig implements IGameModuleConfig {
    public static instance: BookOfShadowsGameModuleConfig = new BookOfShadowsGameModuleConfig();
    public static countUpView: CountUpView;
    public static bigWinView: BookOfShadowsBigWinView;
    public static background: BookOfShadowsBackground;
    public static inactiveRowController: BookOfShadowsInactiveRowController;
    public static reelLockController: BookOfShadowsReelLockController;
    public static symWinAnims: BookOfShadowsSymbolsWinAnimations;
    public static reelBackgroundView: BookOfShadowsReelBackgroundView;
    public static fireParticles: FireParticles;
    public static nearWinView: BookOfShadowsNearWinView;
    public static betLineWinAmountView: BookOfShadowsBetLineWinAmountView;
    public static miniCoinShower: MiniCoinShower;
    public static bigWinFountain: CoinsFountain;
    public static gameTutorial: GameTutorialController;
    public static featurePrice: FeaturePrice;
    private static gameTweakerTest: GameTweakerTest;
    private static betLinesView: BetLinesView;
    private static soundManager: SoundManager;
    private static payTableView: BookOfShadowsPaytableView;

    GAME_CONFIG: IGameConfig = BookOfShadowsGameConfig.instance;
    SOUND_CONFIG: ISoundConfig = BookOfShadowsSoundConfig.instance;
    FONTS_CONFIG: IFontsConfig = BookOfShadowsFontConfig.FONTS;
    RESOURCES_CONFIG: IResourcesGroupConfig = BookOfShadowsGameAssets.RESOURCES_GROUPS;

    GAME_MODE_TRANSITIONS?: (() => GameModeTransitionController)[] = [
        () => {
            return new BookOfShadowsFreeSpinIntroTransitionController(
                BookOfShadowsGameMode.NORMAL,
                BookOfShadowsGameMode.FREESPIN_PICK
            );
        },
        () => {
            return new BookOfShadowsFreeSpinIntroTransitionController(
                BookOfShadowsGameMode.GAMBLE,
                BookOfShadowsGameMode.FREESPIN_PICK
            );
        },
        () => {
            return new BookOfShadowsFreeSpinIntroTransitionController(
                BookOfShadowsGameMode.FREESPIN_PICK,
                BookOfShadowsGameMode.FREESPIN_PICK
            );
        },
        () => {
            return new GameModeTransitionController(
                BookOfShadowsGameMode.FREESPIN_PICK,
                BookOfShadowsGameMode.FREESPIN
            );
        },
        () => {
            return new GambleTransitionController(
                BookOfShadowsGameMode.NORMAL,
                BookOfShadowsGameMode.GAMBLE
            );
        },
        () => {
            return new BookOfShadowsExitGambleTransition(
                BookOfShadowsGameMode.GAMBLE,
                BookOfShadowsGameMode.NORMAL
            );
        },
        () => {
            //Will be the case when you have won > 0 in FS
            return new BookOfShadowsFreeSpinOutroTransitionController(
                BookOfShadowsGameMode.FREESPIN,
                BookOfShadowsGameMode.GAMBLE
            );
        },
        () => {
            //Will only happen if you won nothing in fs.
            return new BookOfShadowsFreeSpinOutroTransitionController(
                BookOfShadowsGameMode.FREESPIN,
                BookOfShadowsGameMode.NORMAL
            );
        },
        () => {
            // Will only happen in case of re-trigger in FS.
            return new BookOfShadowsReTriggerController(
                BookOfShadowsGameMode.FREESPIN,
                BookOfShadowsGameMode.FREESPIN
            );
        }
    ];
    INDIVIDUAL_WIN_PRESENTATION: () => IndividualWinPresentationController;
    REEL_PART_ANIMATOR: (reelId: number) => BookOfShadowsSpinReelPartAnimator = (reelId => new BookOfShadowsSpinReelPartAnimator(reelId));

    constructor() {
        if (BookOfShadowsGameModuleConfig.instance) {
            throw new Error("BookOfShadowsGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }

    SERVER_PARSER: () => ServerDataParser = () => {
        return new BookOfShadowsServerDataParser();
    };

    PARSED_INIT_DATA: (data: any, dataParser: ServerDataParser) => ParsedInitData = (data, dataParser: ServerDataParser) => {
        return new BookOfShadowsParsedInitData(data, <BookOfShadowsServerDataParser>dataParser);
    };

    PARSED_GAME_DATA: (data: any, dataParser: ServerDataParser) => ParsedGameData = (data, dataParser: ServerDataParser) => {
        return new BookOfShadowsParsedGameData(data, <BookOfShadowsServerDataParser>dataParser);
    };

    REEL_PART_CREATOR: () => ReelPartCreator = () => {
        return new ReelPartCreator(
            (symName: string, reelId: number, state?: ISymbolStateConfig): BookOfShadowsReelSymbol => {
                return new BookOfShadowsReelSymbol(symName, reelId, state);
            });
    };

    REEL_CONTROLLER: (reelId: number) => BookOfShadowsReelController = (reelId: number) => {
        return new BookOfShadowsReelController(reelId);
    };

    REELS: () => Reels = () => {
        return new BookOfShadowsTimelineReelsController();
    };

    SYMBOL_STATE_CREATOR: () => ReelSymbolStateCreator = () => {
        return new BookOfShadowsReelSymbolStateCreator();
    };

    GAME_FEATURE_CREATOR: () => void = () => {
        BookOfShadowsGameModuleConfig.soundManager = new SoundManager();

        BookOfShadowsGameModuleConfig.countUpView = new CountUpView();

        BookOfShadowsGameModuleConfig.bigWinView = new BookOfShadowsBigWinView();

        BookOfShadowsGameModuleConfig.gameTweakerTest = new GameTweakerTest();

        BookOfShadowsGameModuleConfig.background = new BookOfShadowsBackground();

        BookOfShadowsGameModuleConfig.inactiveRowController = new BookOfShadowsInactiveRowController();

        BookOfShadowsGameModuleConfig.reelLockController = new BookOfShadowsReelLockController();

        BookOfShadowsGameModuleConfig.symWinAnims = new BookOfShadowsSymbolsWinAnimations();

        BookOfShadowsGameModuleConfig.betLinesView = new BetLinesView(
            {
                map: [
                    17, 18, 15, 14, 12, 2, 7, 1, 5, 3, // left
                    16, 20, 19, 11, 13, 4, 6, 10, 8, 9 // right
                ]
            },
            (index: number): BookOfShadowsTextBetLineNumber => {
                return new BookOfShadowsTextBetLineNumber(index, {
                    layer: BookOfShadowsGameConfig.instance.LAYERS.BET_LINES.name,
                    width: 40,
                    height: 40,
                    horizontalPadding: [
                        -25,
                        -(BookOfShadowsGameConfig.instance.REEL_AREA_POS_X + BookOfShadowsGameConfig.instance.REEL_AREA_WIDTH + 25) + BookOfShadowsGameConfig.instance.GAME_WIDTH
                    ],
                    verticalPadding: [
                        BookOfShadowsGameConfig.instance.REEL_AREA_POS_Y + 40,
                        (BookOfShadowsGameConfig.instance.GAME_HEIGHT - (BookOfShadowsGameConfig.instance.REEL_AREA_POS_Y + BookOfShadowsGameConfig.instance.REEL_AREA_HEIGHT)) + 40
                    ],
                    textStyleNormal: {
                        fontFamily: "Open Sans",
                        fontSize: 20,
                        fill: "#a6759a"
                    },
                    textStyleWin: {
                        fontFamily: "Open Sans",
                        fontSize: 30,
                        fill: "#ffffff",
                        stroke: "#dfb8cd",
                        strokeThickness: 2,
                        padding: 4

                    },
                    textWinScale: 1
                });
            },
            (index: number, numberPosition: number[], betLineData: number[]): PolyBetLine => {
                return new BookOfShadowsBetLine(index, numberPosition, betLineData, {
                    staticLineLayer: BookOfShadowsGameConfig.instance.LAYERS.BET_LINES.name,
                    styles: [
                        {
                            "lineWidth": 3,
                            "color": 0xffffff,
                            "alpha": 1
                        },
                        {
                            "lineWidth": 1,
                            "color": 0xdfb8cd,
                            "alpha": 1
                        }
                    ],
                    numberOffsetX: 20,
                    pointOverlapVerticalOffset: 8
                });
            }
        );

        BookOfShadowsGameModuleConfig.reelBackgroundView = new BookOfShadowsReelBackgroundView();

        BookOfShadowsGameModuleConfig.fireParticles = new FireParticles();

        BookOfShadowsGameModuleConfig.nearWinView = new BookOfShadowsNearWinView();

        BookOfShadowsGameModuleConfig.betLineWinAmountView = new BookOfShadowsBetLineWinAmountView();

        BookOfShadowsGameModuleConfig.miniCoinShower = new MiniCoinShower();

        BookOfShadowsGameModuleConfig.bigWinFountain = new CoinsFountain();

        BookOfShadowsGameModuleConfig.payTableView = new BookOfShadowsPaytableView();

        BookOfShadowsGameModuleConfig.featurePrice = new FeaturePrice();
    };

    GAME_ROUND_CONFIG: () => GameRoundConfig = () => {
        BookOfShadowsGameModuleConfig.gameTutorial = new GameTutorialController();

        return {
            NORMAL: {
                idle: [
                    BookOfShadowsGameModuleConfig.gameTutorial
                ],
                idleLoop: [
                    new BookOfShadowsBetLineWin(),
                    new BookOfShadowsReelLockButtonIdleAnimationController(),
                    new BookOfShadowsSymbolIdleAnimationController()
                ],
                starting: [
                    new SpinStart(),

                    new ReelStart(0, 0),
                    new ReelStart(1, 0),
                    new ReelStart(2, 0),
                    new ReelStart(3, 0),
                    new ReelStart(4, 0)
                ],
                stoppable: [
                    new ReelStop(0),

                    new BookOfShadowsNearWin(1, 1.5),
                    new ReelStop(1),

                    new BookOfShadowsNearWin(2, 1.5),
                    new ReelStop(2),

                    new BookOfShadowsNearWin(3, 1.5),
                    new ReelStop(3),

                    new BookOfShadowsNearWin(4, 1.5),
                    new ReelStop(4),

                    new SpinStop()
                ],
                skippable: [
                    [
                        new InitialWin(),
                        new BigWinStep(BookOfShadowsGameConfig.instance.WIN_RATIOS.normalWin[0], BookOfShadowsGameConfig.instance.WIN_RATIOS.bigWin[0])
                    ],
                    [
                        new BigWinStep(BookOfShadowsGameConfig.instance.WIN_RATIOS.bigWin[0], BookOfShadowsGameConfig.instance.WIN_RATIOS.bigWin[1])
                    ],
                    [
                        new BigWinStep(BookOfShadowsGameConfig.instance.WIN_RATIOS.bigWin[1], BookOfShadowsGameConfig.instance.WIN_RATIOS.bigWin[2])
                    ],
                    [
                        new WinEnd()
                    ]
                ]
            },
            FREESPIN_PICK: {
                idle: [
                    new BookOfShadowsZeroBet()
                ],
                idleLoop: [],
                starting: [
                    new BookOfShadowsGameRoundPresentation(true, false)
                ],
                stoppable: [
                    new BookOfShadowsGameRoundPresentation(false, true)
                ],
                skippable: [[
                    new BookOfShadowsGameRoundPresentation()
                ]]
            },
            FREESPIN: {
                idle: [
                    new BookOfShadowsZeroBet()
                ],
                idleLoop: [],
                starting: [
                    new SpinStart(),

                    new ReelStart(0, 0),
                    new ReelStart(1, 0),
                    new ReelStart(2, 0),
                    new ReelStart(3, 0),
                    new ReelStart(4, 0)
                ],
                stoppable: [
                    new ReelStop(0),

                    new BookOfShadowsNearWin(1, 1.5),
                    new ReelStop(1),

                    new BookOfShadowsNearWin(2, 1.5),
                    new ReelStop(2),

                    new BookOfShadowsNearWin(3, 1.5),
                    new ReelStop(3),

                    new BookOfShadowsNearWin(4, 1.5),
                    new ReelStop(4),

                    new SpinStop()
                ],
                skippable: [
                    [
                        new InitialWin(),
                        new BookOfShadowsScatterWinController()
                    ],
                    [
                        new BigWinStep(BookOfShadowsGameConfig.instance.WIN_RATIOS.bigWin[0], BookOfShadowsGameConfig.instance.WIN_RATIOS.bigWin[1])
                    ],
                    [
                        new BigWinStep(BookOfShadowsGameConfig.instance.WIN_RATIOS.bigWin[1], BookOfShadowsGameConfig.instance.WIN_RATIOS.bigWin[2])
                    ],
                    [
                        new WinEnd()
                    ]
                ]
            },
            GAMBLE: {
                idle: [
                    new BookOfShadowsGambleBet()
                ],
                idleLoop: [
                    new BookOfShadowsBetLineWin()
                ],
                starting: [],
                stoppable: [],
                skippable: [[]]
            }
        }
    };
}